import CardDesignerCardElementBarcode from './CardDesignerCardElementBarcode';

export default CardDesignerCardElementBarcode;
